import NucleusComponentBase from "@/shared/application/nucleus-component-base";
import { Component, Watch } from "vue-property-decorator";
import Guid from "@/shared/helpers/guid-helper";
import { stringify } from "query-string";
import { debug } from "console";

@Component
export default class CommissionListComponent extends NucleusComponentBase {
  refs = this.$refs as any;
  allPermissions: IPermissionDto[] = [];
  errors: INameValueDto[] = [];
  loading = true;
  dialog = false;
  formTitle = "";
  options = {};
  search = "";
  selectAll = false;
  files = [];
  companies = [] as ICompanyListOutput[];
  selectedCompanyFilter = "00000000-0000-0000-0000-000000000000";

  get headers() {
    return [
      { text: this.$t("UserName"), value: "userName" },
      { text: this.$t("InvoiceId"), value: "invoiceId" },
      { text: this.$t("TotalAmount"), value: "total" },
      { text: "Marka Adı", value: "companyName" },
      { text: this.$t("IsHaveUserInCms"), value: "isHaveUserInCms" },
    ];
  }

  createOrUpdateCommissionInput = {
    commission: {} as ICommissionDto,
  } as ICreateOrUpdateCommissionInput;

  pagedListOfCommissionListDto: IPagedList<ICommissionListOutput> = {
    totalCount: 0,
    items: [],
  };

  @Watch("options")
  onPaginationChanged() {
    this.getCommissions();
  }

  @Watch("search")
  onSearchChanged() {
    this.getCommissions();
  }
  @Watch("selectedCompanyFilter")
  onCompanyIdChanged() {
    this.getCommissions();
  }

  mounted() {
    this.getCommissions();
  }

  editCommission(id: string) {
    this.formTitle = id
      ? this.$t("EditCommission").toString()
      : this.$t("NewCommission").toString();
    this.errors = [];
    this.nucleusService
      .get<IGetCommissionForCreateOrUpdateOutput>(
        "/api/Commissions/" + (id ? id : Guid.empty)
      )
      .then((response) => {
        const result = response.content as IGetCommissionForCreateOrUpdateOutput;
        this.createOrUpdateCommissionInput = {
          commission: result.commission,
        };
        this.dialog = true;
      });
  }

  deleteCommission(id: string) {
    this.swalConfirm(this.$t("AreYouSureToDelete").toString()).then(
      (result) => {
        if (result.value) {
          this.nucleusService
            .delete("/api/Commissions?id=" + id)
            .then((response) => {
              if (!response.isError) {
                this.swalToast(
                  2000,
                  "success",
                  this.$t("Successful").toString()
                );
                this.getCommissions();
              } else {
                var errorText = "";
                response.errors.forEach((error) => {
                  errorText += this.$t(error.name) + "<br>";
                });

                this.swalAlert("error", errorText);
              }
            });
        }
      }
    );
  }

  save() {
    if (this.refs.form.validate()) {
      this.errors = [];
      this.nucleusService
        .postOrPut<void>(
          "/api/Commissions",
          this.createOrUpdateCommissionInput as ICreateOrUpdateCommissionInput,
          this.createOrUpdateCommissionInput.commission.id
        )
        .then((response) => {
          if (!response.isError) {
            this.swalToast(2000, "success", this.$t("Successful").toString());
            this.dialog = false;
            this.getCommissions();
          } else {
            this.errors = response.errors;
          }
        });
    }
  }

  getCommissions() {
    this.getCompanies();
    this.loading = true;
    const { sortBy, sortDesc, page, itemsPerPage }: any = this.options;
    const CommissionListInput: IPagedListInput | any = {
      filter: this.search,
      pageIndex: page - 1,
      pageSize: itemsPerPage,
      companyId: this.selectedCompanyFilter,
    };

    if (sortBy.length > 0 && sortBy[0]) {
      CommissionListInput.sortBy =
        sortBy + (sortDesc.length > 0 && sortDesc[0] ? " desc" : "");
    }

    const query = "?" + this.queryString.stringify(CommissionListInput);
    this.nucleusService
      .get<IPagedList<ICommissionListOutput>>("/api/Commissions" + query, false)
      .then((response) => {
        this.pagedListOfCommissionListDto = response.content as IPagedList<
          ICommissionListOutput
        >;
        this.loading = false;
      });
  }
  openFileUploadDialog() {
    var uploaderInput = this.$refs.uploader as HTMLElement;
    uploaderInput.click();
  }
  onFileChanged(e: any) {
    debugger;
    var files = e.target.files[0];
    if (this.files != undefined) {
      this.errors = [];

      var formData = new FormData();
      formData.append("files", files);
      this.nucleusService
        .postExcel<void>("/api/Commissions/UploadWithExcel", formData)
        .then((response) => {
          if (!response.isError) {
            this.swalToast(2000, "success", this.$t("Successful").toString());
            this.dialog = false;
            this.getCommissions();
          } else {
            this.errors = response.errors;
          }
        });
    }
  }
  getCompanies() {
    this.loading = true;
    const { sortBy, sortDesc, page, itemsPerPage }: any = this.options;
    const companyListInput: IPagedListInput | any = {
      filter: this.search,
      pageIndex: page - 1,
      pageSize: itemsPerPage,
    };

    if (sortBy.length > 0 && sortBy[0]) {
      companyListInput.sortBy =
        sortBy + (sortDesc.length > 0 && sortDesc[0] ? " desc" : "");
    }

    const query = "?" + this.queryString.stringify(companyListInput);
    this.nucleusService
      .get<IPagedList<ICompanyListOutput>>("/api/companies" + query, false)
      .then((response) => {
        var companyResponse = response.content as IPagedList<
          ICompanyListOutput
        >;
        this.companies = companyResponse.items;
        this.loading = false;
      });
  }
}
